export default __webpack_public_path__ + "static/media/Delhi_2.d734ee4c.png";